import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { Box, Grid } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import { Alert } from '@material-ui/lab';

class NewSimul extends Component {
    state = {  }
    
    render() {
        const {dureeA, priceTotal, base, priceP, realP } = this.props.simulation
        const Year = parseInt(dureeA/12)
        const Months = parseInt(dureeA - (Year*12))
        return (
            <PopUp
                title="Simulation d'Abonnement"
                submitAction={this.props.save}
                submitTitle="Enregistrer"
                close={this.props.close}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            label="Durée Totale en Mois"
                            onChange={this.props.handleSimulation} 
                            value={dureeA}
                            name="dureeA"
                            helperText="Combien de mois va durer l'abonnement ?"
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="Prix système"
                            onChange={this.props.handleSimulation} value={priceTotal} name="priceTotal"
                            helperText="Prix total du système concerné"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            label="Periodicité Base (Jour)"
                            onChange={this.props.handleSimulation} value={base} name="base"
                            helperText="Fréquence de paiement en jours"
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            label="Prix Par Periode"
                            value={priceP} onChange={this.props.handleSimulation} name="priceP"
                            helperText="Prix à payer pour chaque periode"
                        />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <span className="text-left">* Les valeurs calculées sont arrondies</span>
                        
                        <p>
                            Prix Réel Payé : {realP ? realP : ""}
                            <br/>
                            Différence : {(realP && priceTotal) ? (parseFloat(realP) - parseFloat(priceTotal)) : ""}
                        </p>
                        <Box p={1}>
                            <Alert severity="info">
                                <i>Le client paiera {priceP} tous les {base} jours </i>
                                <i>Le système sera remboursé au bout de {Year} an(s) et {Months} mois </i>
                            </Alert>
                        </Box>
                    </Grid>
                </Grid>
            </PopUp>
        )
        
    }
}

export default NewSimul;



